// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import getCurrentActionOrigin       from './getCurrentActionOrigin';

// ===== Interfaces =====

import {
    ISendResetPasswordEmailPayload,
}                                   from '../interfaces';

const sendResetPasswordEmail = async ({
    test,
    email,
}: {
    test: boolean,
    email: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleSendResetPasswordEmail = httpsCallable<
        ISendResetPasswordEmailPayload,
        boolean
    >(
        functions,
        'sendResetPasswordEmail',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: ISendResetPasswordEmailPayload = {
        test,
        email,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return handleSendResetPasswordEmail(payload).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default sendResetPasswordEmail;
